import React, {Component} from 'react';
import PurchaseForm from './PurchaseForm';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {fetchIpList} from '../../../actions/ipManagement.actions';
import {BulletList, PageContainer, PageSubTitle, PageTitle} from '../../Common/PageComponents';
import {ProductsTable} from '../ProductsComponents';

const stateToProps = state => {
  return {
    ipManagement: state.ipManagement,
    products: state.purchase.products,
  };
};

class Purchase extends Component {
  componentDidMount() {
    this.props.dispatch(fetchIpList());
    window.scrollTo(0, 0);
  }

  render() {
    if (this.props.ipManagement.fetched && this.props.ipManagement.pcSlots.length == 0) {
      alert('IP 등록을 먼저 하신 후, 상품 구매가 가능합니다.');
      return <Redirect to="/my-pc-bang/management/ip-management" />;
    }

    return (
      <PageContainer>
        <PageTitle title="상품 구매하기" />
        <PageSubTitle title="상품별 요금" />
        <div style={{textAlign: 'right', fontSize: '12px'}}>*VAT포함</div>
        <ProductsTable products={this.props.products} style={{margin: '15px 0'}} />
        <div style={{color: '#000'}}>※ 결제 수단: 신용카드, 계좌이체, 가상계좌(일반 결제 전용)</div>
        <PurchaseForm />
        <BulletList
          style={{
            border: '1px solid #E7E7E7',
            color: '#404040',
            padding: '10px 20px',
            marginTop: '45px',
            fontSize: '14px',
            letterSpacing: '-1px',
          }}
        >
          <ul>
            <li>&apos;자동결제&apos;를 이용하시면 상시 잔여 포인트 관리 및 결제의 불편함을 해소하실 수 있습니다.</li>
            <li>
              &apos;자동결제&apos; 해지는
              <Link to="/my-pc-bang/usage-status/auto-payment" style={{margin: '0 5px'}}>
                &apos;MY PC방 &gt; 결제 및 사용 현황 &gt; 자동결제신청/변경&apos;
              </Link>
              페이지에서 가능합니다.
            </li>
            <li>
              &apos;결제취소&apos;는 결제 후, 1주일 이내에 사용하지 않은 제품에 한하여 가능하며, 구매 포인트의 일부가
              소진되거나 1주일이 지난 이후에는 잔여 포인트에 대한 환불이 가능합니다. <br />단 환불 시 환불 수수료가
              발생하게 되니 유의해주시기 바랍니다.
            </li>
            <li>안전한 결제를 위해, 50만원 이상 신용카드 결제 시, 공인인증서를 통해 거래인증이 필요합니다.</li>
            <li>해외에서 발행된 신용카드로는 결제가 불가능합니다.</li>
          </ul>
        </BulletList>
      </PageContainer>
    );
  }
}

export default connect(stateToProps)(Purchase);
